import {AppState} from '@app/context/context';

type NameReport = 'percentsConfig'
    | 'webConfig';

class ReportsColumnsStorage {
    set = (data: Partial<AppState['reports']>, nameReport: NameReport) =>
        localStorage.setItem(nameReport, JSON.stringify(data));

    get = (nameReport: NameReport): AppState['reports'] | null => {
        const storedConfig = localStorage.getItem(nameReport);
        if (storedConfig === null || storedConfig === 'undefined') {
            return null
        }
        return JSON.parse(storedConfig);
    };

    clear = (nameReport: NameReport) =>
        localStorage.removeItem(nameReport);
}

export const reportsColumnsStorage = new ReportsColumnsStorage();